import { useState, useRef, useLayoutEffect } from "react";
import { stripMentionsToText } from "utils/mention";

const PostContentPreview = ({ content }) => {
    const ref = useRef(null);
    // 멘션 토큰은 피드에서 @DisplayName plain text 로 표시(비클릭)
    const displayContent = stripMentionsToText(content);
    const [preview, setPreview] = useState(displayContent);
    const [showMore, setShowMore] = useState(false);

    useLayoutEffect(() => {
        const el = ref.current;
        if (!el || !displayContent) return;

        // 전체 텍스트로 overflow 확인
        el.textContent = displayContent;
        if (el.scrollHeight <= el.clientHeight + 1) {
            setPreview(displayContent);
            setShowMore(false);
            return;
        }

        // 이진 탐색으로 3줄에 맞는 최대 글자 수 찾기
        const suffix = "...더보기";
        let low = 0;
        let high = displayContent.length;
        while (low < high) {
            const mid = Math.floor((low + high + 1) / 2);
            el.textContent = displayContent.slice(0, mid) + suffix;
            if (el.scrollHeight <= el.clientHeight + 1) {
                low = mid;
            } else {
                high = mid - 1;
            }
        }

        setPreview(displayContent.slice(0, low));
        setShowMore(true);
    }, [displayContent]);

    return (
        <div className="post-content" ref={ref}>
            {showMore ? (
                <>
                    {preview}
                    <span className="read-more">...더보기</span>
                </>
            ) : (
                preview
            )}
        </div>
    );
};

export default PostContentPreview;
